import { axios } from "../../lib/axios";

export type PatchLecturePayload = {
  isDemo?: boolean;
  title?: string;
};

export const PatchLecture = (id: string, payload: PatchLecturePayload) => {
  return axios.patch(`/lecture/${id}`, payload).then((res) => res.data);
};
